import { createApiRef } from "@backstage/core-plugin-api";
import type { AskjackApi } from "@internal/plugin-askjack-common";

/**
 * API reference for the AskJack backend client.
 *
 * Import this ref (not the client class) in frontend components to access the
 * AskJack API via `useApi(AskjackRef)`.
 *
 * @public
 */
export const AskjackRef = createApiRef<AskjackApi>({
    id: "askjack",
});
